"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESendingsRequestSource = void 0;
var ESendingsRequestSource;
(function (ESendingsRequestSource) {
    ESendingsRequestSource["API"] = "API";
    ESendingsRequestSource["API-TRUSTED"] = "API-TRUSTED"; // Для запросов по внешнему API, которым можно доверять
})(ESendingsRequestSource || (exports.ESendingsRequestSource = ESendingsRequestSource = {}));
//# sourceMappingURL=SendingRequestSource.enum.js.map